export const SERVICE = 'NOTIFICATIONS'
